import React from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import {
    selectDeviceData,
    selectActiveWeatherSensors,
    selectDeviceDataDatasetStatus,
    selectDeviceDataDatasetVersionDttm,
    setActiveWeatherSensorBySn,
} from "./store/reducers/deviceLinkingAppStoreSlice";
import DatasetDerivedList from "./DatasetDerivedList";

type DeviceListProps = {
    className?: string;
};

export default function WeatherSensorList(props: DeviceListProps): JSX.Element {
    const dispatch = useAppDispatch();
    const dataset = useAppSelector(selectDeviceData);
    const datasetStatus = useAppSelector(selectDeviceDataDatasetStatus);
    const datasetVersion = useAppSelector(selectDeviceDataDatasetVersionDttm);

    const activeWeatherSensors = useAppSelector(selectActiveWeatherSensors);
    return (
        <DatasetDerivedList
            className={props.className}
            dataNotYetLoadedMessage="No data loaded. Select a Client & Project to continue"
            emptyListMessage="No weather sensors in dataset"
            errorMessage="No weather sensors in dataset"
            datasetStatus={datasetStatus}
            datasetType={dataset?.meta?.dataset_type || ""}
            datasetVersion={datasetVersion || ""}
            selectObject={(weather_sensor) =>
                weather_sensor && dispatch(setActiveWeatherSensorBySn(weather_sensor.device_sn))
            }
            isActiveObject={(weather_sensor) => activeWeatherSensors.indexOf(weather_sensor) !== -1}
            objectList={dataset?.data.weather_sensors || []}
            extractObjectKey={(weather_sensor) => weather_sensor.device_sn}
            extractObjectLabel={(weather_sensor) => `Site ${weather_sensor.site_id} / ${weather_sensor.device_sn}`}
            sortByLabel={true}
        />
    );
}
